/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { request, postRequest } from 'embercom/lib/inbox/requests';

export default class FinPlaygroundApiService extends Service {
  @service declare appService: $TSFixMe;

  async getToken(): Promise<string | null> {
    try {
      let response = await request(
        `/ember/developer_home/app_package_tokens?app_id=${this.appService.app.id}`,
      );
      let parsedResponse = await response.json();
      return parsedResponse.token;
    } catch (error) {
      // 404 means no token exists, which is expected
      if (error instanceof Error && 'status' in error && (error as any).status === 404) {
        return null;
      }
      throw error;
    }
  }

  async createToken(): Promise<string> {
    let response = await postRequest(
      `/ember/developer_home/app_package_tokens?app_id=${this.appService.app.id}`,
    );

    if (response.error) {
      throw new Error(response.error);
    }

    if (!response.token) {
      throw new Error('Failed to create token');
    }

    let parsedResponse = await response.json();
    return parsedResponse.token;
  }
}
